'use es6';

import { resetRssFeedUrlValidation, validateRssUrl } from 'EmailData/actions';
import { getRssFeedUrlValidationLoading, getRssFeedUrlValidationResult } from 'EmailData/selectors/rssFeedUrlValidationSelectors';
import { RSS_STATUS_ALERT_TYPE, RSS_STATUS_TYPES, VALID_RSS_STATUS_TYPES } from 'EmailData/utils/constants';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UIAlert from 'UIComponents/alert/UIAlert';
import UIButton from 'UIComponents/button/UIButton';
import SyntheticEvent from 'UIComponents/core/SyntheticEvent';
import Small from 'UIComponents/elements/Small';
import UIForm from 'UIComponents/form/UIForm';
import UIGrid from 'UIComponents/grid/UIGrid';
import UIGridItem from 'UIComponents/grid/UIGridItem';
import UIIcon from 'UIComponents/icon/UIIcon';
import UILink from 'UIComponents/link/UILink';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import UITable from 'UIComponents/table/UITable';
import UITruncateString from 'UIComponents/text/UITruncateString';
import { Box } from 'foundations-components/transitional/components/Box';
import PropTypes from 'prop-types';
import { Component, createRef } from 'react';
import { connect } from 'react-redux';
import debounce from 'react-utils/debounce';
import emptyFunction from 'react-utils/emptyFunction';
import RssStatusMessage from './RssStatusMessage';
import UrlFieldWithProtocol from './UrlFieldWithProtocol';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const mapStateToProps = state => {
  const result = getRssFeedUrlValidationResult(state);
  return {
    isLoading: getRssFeedUrlValidationLoading(state),
    status: result.get('feedResultStatus'),
    feedList: result.get('feedList'),
    lastUrlValidated: result.get('feedUrl'),
    hubspotContentGroupId: result.get('hubspotContentGroupId')
  };
};
class RssUrlField extends Component {
  constructor(props) {
    super(props);
    this.getShowInfoAndShowErrorValues = () => {
      const {
        status,
        isLoading
      } = this.props;
      const showError = status.length > 0 && !VALID_RSS_STATUS_TYPES.includes(status) && !isLoading && this.state.value === this.props.value;
      const showInfo = status.length > 0 && !showError;
      return {
        showInfo,
        showError
      };
    };
    this.validateRssUrlDebounced = debounce(this.props.validateRssUrl, 1000);
    this.onCloseHubspotAlert = this.onCloseHubspotAlert.bind(this);
    this.onSelectBlog = this.onSelectBlog.bind(this);
    this.renderFeedList = this.renderFeedList.bind(this);
    this.renderInfoMessage = this.renderInfoMessage.bind(this);
    this.state = {
      value: props.value
    };
    this._inputRef = /*#__PURE__*/createRef();
  }
  componentWillUnmount() {
    if (this.state.value !== this.props.value) {
      this.props.resetRssFeedUrlValidation();
    }
  }
  onRssFieldChange(url, validateImmediately = false) {
    if (validateImmediately === true) {
      this.props.validateRssUrl(url);
    } else {
      this.validateRssUrlDebounced(url);
    }
    this.setState({
      value: url
    });
    this.props.onChange({
      target: {
        value: url
      }
    });
  }
  onCloseHubspotAlert() {
    this.setState({
      dismissedHubspotBlogAlert: true
    });
  }
  onSelectBlog() {
    const {
      hubspotContentGroupId
    } = this.props;
    this.props.resetRssFeedUrlValidation();
    this.props.onSelectBlog(SyntheticEvent(hubspotContentGroupId));
  }
  maybeRenderHubspotPoweredInfo() {
    const {
      hubspotContentGroupId
    } = this.props;
    const {
      dismissedHubspotBlogAlert
    } = this.state;
    if (dismissedHubspotBlogAlert || !hubspotContentGroupId) {
      return null;
    }
    return /*#__PURE__*/_jsx(UIAlert, {
      className: "m-top-2",
      closeable: true,
      onClose: this.onCloseHubspotAlert,
      children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "EmailComponentsCrossFrame.rssUrl.hubspotPowered_jsx",
        options: {
          onClick: () => this.onSelectBlog()
        },
        elements: {
          Link: UILink
        }
      })
    });
  }
  renderFeedList() {
    const {
      status,
      feedList
    } = this.props;
    const items = feedList.toJSON();
    if (status !== RSS_STATUS_TYPES.FOUND_RSS_FEEDS) {
      return null;
    }
    return /*#__PURE__*/_jsxs(UITable, {
      truncated: true,
      children: [/*#__PURE__*/_jsxs("colgroup", {
        children: [/*#__PURE__*/_jsx("col", {}), /*#__PURE__*/_jsx("col", {}), /*#__PURE__*/_jsx("col", {
          style: {
            width: 110
          }
        })]
      }), /*#__PURE__*/_jsx("thead", {
        children: /*#__PURE__*/_jsxs("tr", {
          children: [/*#__PURE__*/_jsx("th", {
            children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: "EmailComponentsCrossFrame.rssUrl.title"
            })
          }), /*#__PURE__*/_jsx("th", {
            children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: "EmailComponentsCrossFrame.rssUrl.url"
            })
          }), /*#__PURE__*/_jsx("th", {
            children: ''
          })]
        })
      }), /*#__PURE__*/_jsx("tbody", {
        children: items.map(item => /*#__PURE__*/_jsxs("tr", {
          children: [/*#__PURE__*/_jsx("td", {
            children: /*#__PURE__*/_jsx(UITruncateString, {
              children: item.title
            })
          }), /*#__PURE__*/_jsx("td", {
            children: /*#__PURE__*/_jsx(UILink, {
              href: item.url,
              external: true,
              iconProps: {
                style: {
                  display: 'none'
                }
              },
              children: /*#__PURE__*/_jsx(UITruncateString, {
                useFlex: true,
                fixedChildren: /*#__PURE__*/_jsx(UIIcon, {
                  className: "m-left-2",
                  name: "externalLink",
                  size: "xxs"
                }),
                children: item.url
              })
            })
          }), /*#__PURE__*/_jsx("td", {
            children: /*#__PURE__*/_jsx(UIButton, {
              size: "small",
              use: "tertiary-light",
              onClick: () => this.onRssFieldChange(item.url, true),
              children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
                message: "EmailComponentsCrossFrame.rssUrl.useFeedButton"
              })
            })
          })]
        }, item.url))
      })]
    });
  }
  renderInfoMessage() {
    const {
      status
    } = this.props;
    const message = /*#__PURE__*/_jsx(Small, {
      use: "help",
      weight: "medium",
      "data-test-id": status,
      children: /*#__PURE__*/_jsx(RssStatusMessage, {
        status: status
      })
    });
    if (status in RSS_STATUS_ALERT_TYPE) {
      return /*#__PURE__*/_jsx(UIAlert, {
        type: RSS_STATUS_ALERT_TYPE[status],
        children: message
      });
    }
    return message;
  }
  renderRssUrlField() {
    const {
      isLoading,
      inputSize,
      status
    } = this.props;
    const {
      showInfo,
      showError
    } = this.getShowInfoAndShowErrorValues();
    return /*#__PURE__*/_jsxs(UIGrid, {
      children: [/*#__PURE__*/_jsx(UIGridItem, {
        size: {
          xs: inputSize
        },
        children: /*#__PURE__*/_jsxs(UIForm, {
          children: [/*#__PURE__*/_jsx(UrlFieldWithProtocol, {
            validationMessage: /*#__PURE__*/_jsx(RssStatusMessage, {
              status: status
            }),
            showError: !this.props.isLoading && showError,
            onUrlChange: updatedUrl => this.onRssFieldChange(updatedUrl),
            value: this.state.value,
            onBlur: this.props.onBlur
          }), showInfo && this.renderInfoMessage(showInfo)]
        })
      }), /*#__PURE__*/_jsx(UIGridItem, {
        size: {
          xs: 1
        },
        children: /*#__PURE__*/_jsx(Box, {
          alignSelf: "flex-end",
          children: isLoading && /*#__PURE__*/_jsx(UILoadingSpinner, {})
        })
      })]
    });
  }
  render() {
    return /*#__PURE__*/_jsxs("div", {
      "data-test-id": "rss-url-field",
      children: [this.renderRssUrlField(), this.maybeRenderHubspotPoweredInfo(), this.renderFeedList()]
    });
  }
}
RssUrlField.defaultProps = {
  onBlur: emptyFunction,
  inputSize: 11
};
RssUrlField.propTypes = {
  value: PropTypes.string,
  inputSize: PropTypes.number,
  isLoading: PropTypes.bool.isRequired,
  status: PropTypes.string,
  feedList: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  validateRssUrl: PropTypes.func,
  className: PropTypes.string,
  style: PropTypes.object,
  resetRssFeedUrlValidation: PropTypes.func,
  hubspotContentGroupId: PropTypes.number,
  onSelectBlog: PropTypes.func
};
export default connect(mapStateToProps, {
  validateRssUrl,
  resetRssFeedUrlValidation
})(RssUrlField);